export default "__VITE_ASSET__wmwm$aJA__"